const FeatureConfigs = {
  ForecastedTension:
    'https://onemap-eaa.bpglobal.com/hostedserver/rest/services/bpGTADownManning/FeatureServer/0',
  ActualTension:
    'https://onemap-eaa.bpglobal.com/hostedserver/rest/services/bpGTADownManning/FeatureServer/4',
  ForecastedWaveHeightPeriod:
    'https://onemap-eaa.bpglobal.com/hostedserver/rest/services/bpGTADownManning/FeatureServer/1',
  ActualWaveHeight:
    'https://onemap-eaa.bpglobal.com/hostedserver/rest/services/bpGTADownManning/FeatureServer/2',
  ActualWavePeriod:
    'https://onemap-eaa.bpglobal.com/hostedserver/rest/services/bpGTADownManning/FeatureServer/3',
};

export default FeatureConfigs;